<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>营销策略</el-breadcrumb-item>
				<el-breadcrumb-item> 产品访问记录 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.resourcesName" placeholder="请输入公司名称" class="handle-input mr10" style="width:220px"></el-input>
				<el-select v-model="query.typeId" placeholder="请选择产品类型" @change="onChangeTypeId" filterable style="width:180px">
					<el-option key="" label="请选择产品类型" value=""></el-option>
					<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.seriesId" placeholder="请选择产品系列" filterable style="width:180px">
					<el-option key="" label="请选择产品系列" value=""></el-option>
					<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.visitTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:200px"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.visitTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:200px"
				></el-date-picker>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="resourcesName" label="资源名称" width="280px"></el-table-column>
				<el-table-column prop="mail" label="访问邮件" width="200px"></el-table-column>
                <el-table-column prop="seriesName" label="产品">
					<template slot-scope="scope">
						{{scope.row.typeName?scope.row.typeName:""}}{{scope.row.seriesName?(scope.row.typeName?"/":"") + scope.row.seriesName:""}}{{scope.row.productName?"/"+scope.row.productName:""}}
					</template>
				</el-table-column>
				<el-table-column prop="visitProductTime" label="访问时间" width="180px"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchMarketingProductVisitData, getEnumValueKV, getProductSeriesKV} from '../../../api/index';
export default {
    name: 'market-mail-plan',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
			productTypeKV:[],
			productTypeEnumCode:1003,
			productSeriesKV:[]
        };
    },
    created() {
		this.controll = getControll("market-product-visit");
        this.getData();
		this.getProductType();
    },
    methods: {
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.productSeriesKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
        // 获取数据
        getData() {
            fetchMarketingProductVisitData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
